const de = {
  common: {
    languages: { en: "English", de: "Deutsch", nl: "Nederlands", fr: "Français" },
  },

  maintenance: {
    title: "Wartungsarbeiten",
    body: "Sibolab wird derzeit gewartet. Wir sind in Kürze wieder online. Vielen Dank für Ihre Geduld.",
  },

  updateBanner: {
    message: "Eine neue Version des Portals ist verfügbar.",
    refresh: "Aktualisieren",
    close: "Schließen",
  },

  session: {
    accessChanged: "Ihre Zugriffsrechte wurden geändert, daher stehen Ihnen einige Seiten nicht mehr zur Verfügung. Bitte wenden Sie sich an Sibolab, falls Sie dies für einen Fehler halten.",
  },

  sidebar: {
    portalLabels: {
      admin: "Admin-Portal öffnen",
      therapist: "Therapeuten-Portal öffnen",
      patient: "Kundenportal öffnen",
    },
    roleLabels: {
      admin: "Admin",
      operator: "Operator",
      therapist: "Therapeut",
      patient: "Kunde",
    },
    nav: {
      dashboard: "Dashboard",
      myOrders: "Meine Bestellungen",
      myReports: "Meine Berichte",
      myPatients: "Meine Patienten",
      reports: "Berichte",
    },
    account: {
      signedIn: "Angemeldet",
      settings: "Einstellungen",
      logout: "Abmelden",
    },
  },

  languageSwitcher: {
    promptTitle: "Portalsprache ändern?",
    promptBody: "Soll dies jedes Mal Ihre Sprache sein, wenn Sie sich anmelden, oder nur für diese Sitzung?",
    justForNow: "Nur für jetzt",
    saveForNextTime: "Für nächstes Mal speichern",
  },

  twoFactorPrompt: {
    title: "Wie möchten Sie sich anmelden?",
    body: "Für zusätzliche Sicherheit können wir Ihnen bei jeder Anmeldung einen Einmalcode per E-Mail senden. Wenn Sie dies deaktivieren, melden Sie sich nur mit E-Mail-Adresse und Passwort an.",
    enable: "E-Mail-Code beibehalten (empfohlen)",
    disable: "Ohne Code anmelden",
    changeLater: "Sie können dies jederzeit unter Einstellungen → Konto ändern.",
    error: "Ihre Auswahl konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  },
  settings: {
    dialog: {
      groupLabel: "Einstellungen",
      general: "Allgemein",
      account: "Konto",
    },
    unsaved: {
      title: "Ungespeicherte Änderungen",
      body: "Sie haben Änderungen, die noch nicht gespeichert wurden. Möchten Sie sie vor dem Verlassen speichern?",
      save: "Änderungen speichern",
      discard: "Verwerfen",
      keepEditing: "Weiter bearbeiten",
      saveError: "Einige Änderungen konnten nicht gespeichert werden. Bitte prüfen Sie die Hinweise auf der Seite.",
    },
    general: {
      title: "Profil",
      fullName: "Vollständiger Name",
      country: "Land",
      countryPlaceholder: "Land auswählen",
      language: "Sprache",
      languagePlaceholder: "Sprache auswählen",
      lastLogin: "Letzte Anmeldung: {{date}}",
      memberSince: "Mitglied seit: {{date}}",
      saveChanges: "Änderungen speichern",
      profileUpdated: "Profil aktualisiert",
      loadError: "Profil konnte nicht geladen werden",
      saveError: "Profil konnte nicht aktualisiert werden",
    },
    account: {
      title: "Konto",
      changePassword: "Passwort ändern",
      previousPasswordPlaceholder: "Aktuelles Passwort",
      newPasswordPlaceholder: "Neues Passwort",
      confirmNewPasswordPlaceholder: "Neues Passwort bestätigen",
      cancel: "Abbrechen",
      updatePassword: "Passwort aktualisieren",
      passwordUpdated: "Passwort erfolgreich aktualisiert.",
      errors: {
        fillAllFields: "Bitte füllen Sie alle Passwortfelder aus.",
        mismatch: "Neues Passwort und Bestätigung stimmen nicht überein.",
        requirements: "Das neue Passwort erfüllt nicht die oben genannten Anforderungen.",
        generic: "Passwort konnte nicht geändert werden",
      },
      twoFactor: {
        title: "Zwei-Schritt-Anmeldung (E-Mail-Code)",
        label: "Bei der Anmeldung einen E-Mail-Code anfordern",
        noteOn: "Wir senden Ihnen bei jeder Anmeldung einen Einmalcode per E-Mail.",
        noteOff: "Sie melden sich nur mit E-Mail-Adresse und Passwort an (weniger sicher).",
        save: "Speichern",
        saved: "Einstellung zur Zwei-Schritt-Anmeldung gespeichert.",
        saveError: "Die Einstellung zur Zwei-Schritt-Anmeldung konnte nicht gespeichert werden.",
        loadError: "Ihre Einstellung zur Zwei-Schritt-Anmeldung konnte nicht geladen werden.",
        confirmTitleOn: "Zwei-Schritt-Anmeldung aktivieren?",
        confirmBodyOn: "Ab Ihrer nächsten Anmeldung senden wir Ihnen bei jeder Anmeldung einen Einmalcode per E-Mail.",
        confirmTitleOff: "Zwei-Schritt-Anmeldung deaktivieren?",
        confirmBodyOff: "Ab Ihrer nächsten Anmeldung melden Sie sich nur mit E-Mail-Adresse und Passwort an - ohne E-Mail-Code. Das ist weniger sicher.",
        confirm: "Bestätigen",
        cancel: "Abbrechen",
      },
      communicationPreferences: {
        title: "Kommunikationseinstellungen",
        loadError: "Ihre Kommunikationseinstellungen konnten nicht geladen werden.",
        savePreferences: "Einstellungen speichern",
        saved: "Einstellungen gespeichert.",
        saveError: "Einstellungen konnten nicht gespeichert werden.",
      },
      therapistApplication: {
        title: "Therapeutenantrag",
        pending: "Ihr Antrag wird geprüft.",
        revoked: "Ihr Therapeutenzugang wurde widerrufen. Bei Fragen wenden Sie sich bitte an den Support.",
        rejected: "Ihr Antrag wurde nicht genehmigt. Bei Fragen wenden Sie sich bitte an den Support.",
        reapply: "Erneut beantragen",
        interested: "Möchten Sie Ihre Leistungen über Sibolab anbieten? Beantragen Sie den Therapeutenstatus.",
        apply: "Therapeutenstatus beantragen",
        cancel: "Abbrechen",
        submit: "Antrag einreichen",
        errors: {
          fieldsRequired: "Geben Sie Praxisname, Stadt und E-Mail-Adresse ein.",
          docsRequired: "Fügen Sie mindestens ein Lizenz- oder Zertifikatsdokument hinzu.",
          generic: "Beim Einreichen Ihres Antrags ist ein Fehler aufgetreten.",
        },
      },
    },
  },

  auth: {
    emailHint: "Die E-Mail kann einen Moment dauern. Bitte prüfen Sie auch Ihren Spam- oder Junk-Ordner.",
    layout: {
      title: "Portal Sibolab",
      subtitleDesktop:
        "Verwalten Sie Labortests, verfolgen Sie Bestellungen, analysieren Sie Ergebnisse und optimieren Sie Ihren Laborworkflow — alles an einem Ort.",
      subtitleMobile: "Verwalten Sie Labortests, verfolgen Sie Bestellungen und sehen Sie Ergebnisse an einem Ort ein.",
      copyright: "© {{year}} Sibolab. Alle Rechte vorbehalten.",
    },

    login: {
      title: "Anmelden",
      subtitle: "Geben Sie Ihre Zugangsdaten ein, um auf das Portal zuzugreifen",
      emailPlaceholder: "ihre@email.com",
      passwordPlaceholder: "Passwort",
      emailRequired: "E-Mail ist erforderlich",
      invalidEmail: "Ungültige E-Mail-Adresse",
      passwordRequired: "Passwort ist erforderlich",
      forgotPassword: "Passwort vergessen?",
      submit: "Anmelden",
      submitting: "Anmeldung läuft...",
      newToSibolab: "Neu bei Sibolab?",
      createAccount: "Konto erstellen",
      errors: {
        shadowAccount: "Sie haben noch kein Portal-Konto. Bitte erstellen Sie eines mit dieser E-Mail-Adresse.",
        badRequest: "E-Mail und Passwort sind erforderlich.",
        invalidCredentials: "Falsche E-Mail-Adresse oder falsches Passwort.",
        inactive: "Dieses Konto ist inaktiv. Bitte wenden Sie sich an einen Administrator.",
        tooMany: "Zu viele Anmeldeversuche. Bitte warten Sie einige Minuten und versuchen Sie es erneut.",
        generic: "Anmeldung derzeit nicht möglich. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      },
      otp: {
        title: "Bestätigungscode eingeben",
        subtitle: "Wir haben einen 6-stelligen Code an {{email}} gesendet. Geben Sie ihn unten ein.",
        incorrectCode: "Falscher oder abgelaufener Code. Bitte prüfen Sie den Code in Ihrer E-Mail und versuchen Sie es erneut oder fordern Sie einen neuen an.",
        verify: "Code bestätigen",
        verifying: "Wird überprüft…",
        notSeeing: "E-Mail nicht erhalten?",
        sendNewCode: "Neuen Code senden",
        sending: "Wird gesendet…",
        wrongEmail: "Falsche E-Mail-Adresse?",
        changeEmail: "E-Mail-Adresse ändern",
        resendNotice: "Ein neuer Code wurde gesendet - überprüfen Sie Ihre E-Mails und geben Sie ihn unten ein.",
        resendError: "Erneutes Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",
      },
    },

    register: {
      emailStep: {
        title: "Konto erstellen",
        subtitle: "Geben Sie Ihre E-Mail-Adresse ein, um zu beginnen.",
        submit: "Weiter",
      },
      alreadyHaveAccount: "Sie haben bereits ein Konto?",
      signIn: "Anmelden",
      errors: {
        tooMany: "Zu viele Versuche - bitte warten Sie einige Minuten und versuchen Sie es erneut.",
        generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      accountExists: {
        title: "Konto existiert bereits",
        withTherapist:
          "Dieses Konto existiert bereits. Melden Sie sich an - von dort können Sie sich bei Bedarf als Therapeut bewerben.",
        withoutTherapist: "Dieses Konto existiert bereits, bitte melden Sie sich an.",
        goToLogin: "Zur Anmeldung",
        wrongEmail: "Falsche E-Mail-Adresse?",
        tryDifferent: "Andere E-Mail-Adresse verwenden",
      },
      otp: {
        title: "Überprüfen Sie Ihre E-Mails",
        subtitle: "Wir haben einen 6-stelligen Code an {{email}} gesendet. Geben Sie ihn unten ein.",
        tooMany: "Zu viele Versuche, bitte versuchen Sie es später erneut.",
        incorrectCode: "Falscher oder abgelaufener Code. Bitte prüfen Sie den Code in Ihrer E-Mail und versuchen Sie es erneut oder fordern Sie einen neuen an.",
        verify: "Code bestätigen",
        checking: "Wird geprüft…",
        resent: "Code erneut gesendet - überprüfen Sie Ihre E-Mails.",
        notSeeing: "E-Mail nicht erhalten?",
        sendNewCode: "Neuen Code senden",
        wrongEmail: "Falsche E-Mail-Adresse?",
        changeEmail: "E-Mail-Adresse ändern",
        resendError: "Der Code konnte nicht erneut gesendet werden. Bitte versuchen Sie es erneut.",
      },
      completeErrors: {
        expiredCode: "Ihr Code ist abgelaufen. Bitte erneut bestätigen.",
        accountExists: "Für diese E-Mail-Adresse existiert bereits ein Konto.",
        tooMany: "Zu viele Versuche, bitte versuchen Sie es später erneut.",
        generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      therapistApplyFailure:
        "Konto erstellt - Ihre Therapeutenbewerbung konnte nicht übermittelt werden: {{reason}}. Sie können es erneut über die Kontoeinstellungen versuchen.",
    },

    registerDetails: {
      title: "Konto fertigstellen",
      subtitle: "Code bestätigt - nur noch ein paar Angaben, dann sind Sie dabei.",
      namePlaceholder: "Name (optional)",
      countryPlaceholder: "Land auswählen",
      languagePlaceholder: "Sprache auswählen",
      countryRequired: "Bitte wählen Sie Ihr Land aus",
      languageRequired: "Bitte wählen Sie Ihre Sprache aus",
      passwordPlaceholder: "Passwort",
      confirmPasswordPlaceholder: "Passwort bestätigen",
      passwordRequired: "Passwort ist erforderlich",
      passwordRequirements: "Das Passwort erfüllt nicht die oben genannten Anforderungen",
      passwordsMismatch: "Die Passwörter stimmen nicht überein",
      therapistFieldsRequired: "Geben Sie Praxisname, Stadt und E-Mail-Adresse ein, um sich als Therapeut zu bewerben",
      therapistDocsRequired: "Fügen Sie mindestens eine Lizenz oder ein Zertifikat hinzu",
      registerAsTherapist: "Als Therapeut registrieren",
      registerAsTherapistDesc: "Reichen Sie Ihre Praxisdaten und Lizenz zur Prüfung durch einen Administrator ein.",
      submit: "Konto erstellen",
      submitting: "Einen Moment bitte…",
    },

    forgotPassword: {
      title: "Passwort zurücksetzen",
      subtitle: "Geben Sie die E-Mail-Adresse Ihres Kontos ein, wir senden Ihnen einen Code.",
      submit: "Code zum Zurücksetzen senden",
      rememberedIt: "Erinnert?",
      signIn: "Anmelden",
      errors: {
        tooMany: "Zu viele Versuche — bitte warten Sie einige Minuten und versuchen Sie es erneut.",
        generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      code: {
        title: "Bestätigungscode eingeben",
        subtitle: "Falls für {{email}} ein Konto existiert, haben wir einen 6-stelligen Code gesendet. Geben Sie ihn unten ein.",
        verify: "Code bestätigen",
        checking: "Wird geprüft…",
        resent: "Code erneut gesendet — überprüfen Sie Ihre E-Mails.",
        notSeeing: "E-Mail nicht erhalten?",
        tryAgain: "Erneut senden",
        wrongEmail: "Falsche E-Mail-Adresse?",
        changeEmail: "E-Mail-Adresse ändern",
        incorrectCode: "Falscher oder abgelaufener Code. Bitte prüfen Sie den Code in Ihrer E-Mail und versuchen Sie es erneut oder fordern Sie einen neuen an.",
        tooMany: "Zu viele Versuche, bitte versuchen Sie es später erneut.",
        resendError: "Der Code konnte nicht erneut gesendet werden. Bitte versuchen Sie es erneut.",
      },
      done: {
        title: "Passwort aktualisiert",
        subtitle: "Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
        goToSignIn: "Zur Anmeldung",
      },
      completeErrors: {
        tooMany: "Zu viele Versuche, bitte versuchen Sie es später erneut.",
        generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      needsRegistration: {
        title: "Noch kein Passwort festgelegt",
        subtitle: "Wir haben ein Konto für diese E-Mail-Adresse gefunden, aber es wurde noch kein Passwort festgelegt. Erstellen Sie eines, um Zugriff zu erhalten.",
        cta: "Konto erstellen",
      },
      notFound: {
        title: "Kein Konto gefunden",
        subtitle: "Wir konnten kein Konto für diese E-Mail-Adresse finden.",
        cta: "Konto erstellen",
        tryDifferentEmail: "Andere E-Mail-Adresse verwenden",
      },
    },

    expiredLink: {
      title: "Dieser Code ist abgelaufen",
      contactPrefix: "Falls das Problem weiterhin besteht, wenden Sie sich bitte an den",
      contactLink: "Support",
      tryAgain: "Erneut versuchen",
    },

    setNewPassword: {
      title: "Neues Passwort festlegen",
      subtitle: "Code bestätigt — legen Sie ein neues Passwort für Ihr Konto fest.",
      newPasswordPlaceholder: "Neues Passwort",
      confirmPasswordPlaceholder: "Neues Passwort bestätigen",
      passwordRequired: "Passwort ist erforderlich",
      passwordRequirements: "Das Passwort erfüllt nicht die oben genannten Anforderungen",
      passwordsMismatch: "Die Passwörter stimmen nicht überein",
      submit: "Passwort aktualisieren",
      submitting: "Einen Moment bitte…",
    },

    emailStep: {
      emailRequired: "E-Mail ist erforderlich",
      invalidEmail: "Ungültige E-Mail-Adresse",
    },

    passwordStrength: {
      length: "Mindestens 8 Zeichen",
      lowercase: "Ein Kleinbuchstabe",
      uppercase: "Ein Großbuchstabe",
      number: "Eine Zahl",
      special: "Ein Sonderzeichen",
    },

    consent: {
      portalUpdates: "Halten Sie mich über neue Portalfunktionen und Ankündigungen auf dem Laufenden.",
      marketing: "Senden Sie mir den IBS/SIBO/IMO-Newsletter.",
    },

    therapistApply: {
      practiceDetails: "Praxisdetails",
      reviewNotice: "Ein Administrator prüft dies, bevor Ihr Therapeutenkonto aktiviert wird.",
      practiceName: "Praxisname",
      practiceNamePlaceholderPortal: "z. B. Kunz Naturheilpraxis",
      practiceCity: "Stadt der Praxis",
      practiceCityPlaceholderPortal: "z. B. Berlin",
      practiceEmail: "E-Mail der Praxis",
      practiceEmailHelp: "Dies ist die E-Mail-Adresse Ihres Kontos und kann hier nicht geändert werden.",
      licenseCertificates: "Lizenz / Zertifikate",
    },

    documentUpload: {
      clickOrDrag: "Klicken zum Hochladen oder per Drag & Drop",
      hint: "PDF, PNG oder JPEG, bis zu 10 MB pro Datei - {{count}}/{{max}} hinzugefügt.",
      tooMany: "Sie können bis zu {{max}} Dokumente hochladen.",
      invalidType: "{{name}}: Nur PDF-, PNG- und JPEG-Dateien sind erlaubt.",
      tooLarge: "{{name}}: Datei überschreitet das 10-MB-Limit.",
    },

    copyButton: {
      copy: "Code kopieren",
      copied: "Kopiert",
    },
  },

  portal: {
    statusTimeline: {
      steps: {
        unprocessed: {
          label: "Bestellung eingegangen",
          bullets: ["Ihre Bestellung ist eingegangen und wird vorbereitet."],
        },
        dispatched: {
          label: "Testkit versendet",
          bullets: [
            "Ihr Testkit ist auf dem Weg zu Ihnen.",
            "Sie erhalten die Sendungsverfolgung per E-Mail.",
          ],
        },
        received_by_customer: {
          label: "Testkit zugestellt",
          bullets: [
            "Ihr Testkit wurde zugestellt.",
            "Führen Sie den Test durch und senden Sie Ihre Probe mit dem frankierten Rücksendeetikett zurück.",
          ],
        },
        returned_to_lab: {
          label: "Probe im Labor eingegangen",
          bullets: [
            "Wir haben Ihre zurückgesendete Probe erhalten.",
            "Sie wartet nun auf die Analyse.",
          ],
        },
        processing: {
          label: "Analyse läuft",
          bullets: [
            "Ihre Probe wird analysiert.",
            "Ihr Bericht ist in 2-3 Werktagen fertig.",
          ],
        },
        analysis_completed: {
          label: "Analyse abgeschlossen",
          bullets: [
            "Ihre Analyse ist abgeschlossen.",
            "Ihr Bericht wird in Kürze bereitgestellt.",
          ],
        },
        completed: {
          label: "Bericht bereit",
          bullets: ["Ihr Bericht ist bereit.", "Sie können ihn unten ansehen oder herunterladen."],
        },
        cancelled: {
          label: "Storniert",
          bullets: ["Dieser Test wurde storniert."],
        },
      },
      cancelledReasons: {
        customer: "Vom Kunden storniert",
      },
      tooltip: {
        completed: "{{label}} — Abgeschlossen am {{date}}",
        inProgress: "{{label}} — In Bearbeitung seit {{date}}",
      },
    },

    statusFilterChips: {
      all: "Alle",
    },

    orderTestActionChips: {
      copied: "Kopiert",
      copyFormLink: "Formularlink kopieren",
      fillOutForm: "Formular ausfüllen",
      reportProcessing: "Bericht wird verarbeitet",
    },

    viewDownloadButtons: {
      viewReport: "Bericht ansehen",
      download: "Herunterladen",
      reportNotFound: "Bericht nicht gefunden.",
      fetchLinkError: "Der Berichtslink konnte nicht abgerufen werden.",
    },

    roleSwitchIndicator: {
      viewingAs: "Angezeigt als {{role}}",
    },

    dashboard: {
      recentActivity: {
        title: "Letzte Aktivitäten",
        subtitle: "Ihre letzten 5 Statusänderungen",
        empty: "Noch keine aktuellen Aktivitäten.",
      },
      patient: {
        pageTitle: "Dashboard",
        pageSubtitle: "Ein Überblick über Ihre Bestellungen und Berichte.",
        summary: {
          totalOrders: "Bestellungen gesamt",
          inProgress: "In Bearbeitung",
          completed: "Abgeschlossen",
          reportsAvailable: "Verfügbare Berichte",
        },
        reportsReady: {
          one: "{{count}} Bericht ist bereit zur Ansicht",
          other: "{{count}} Berichte sind bereit zur Ansicht",
        },
        goToReports: "Zu Meine Berichte",
        loadError: "Ihr Dashboard konnte nicht geladen werden.",
      },
      therapist: {
        pageTitle: "Dashboard",
        pageSubtitle: "Ein Überblick über Ihre Patienten und Tests.",
        summary: {
          totalPatients: "Patienten gesamt",
          totalTests: "Tests gesamt",
          completedThisMonth: "Diesen Monat abgeschlossen",
          inProgress: "In Bearbeitung",
        },
        loadError: "Ihr Dashboard konnte nicht geladen werden.",
      },
    },

    orders: {
      patient: {
        title: "Meine Bestellungen",
        subtitle: "Verfolgen Sie Ihre Testkits von der Bestellung bis zum Bericht.",
        emptyAll: "Sie haben noch keine Bestellungen.",
        emptyFiltered: "Keine Bestellungen entsprechen diesem Filter.",
        loadError: "Ihre Bestellungen konnten nicht geladen werden.",
      },
      therapist: {
        title: "Patientenbestellungen",
        subtitle: "Testfortschritt für diesen Patienten.",
        backLabel: "Zurück zu Patienten",
        emptyAll: "Noch keine Tests für diesen Patienten.",
        emptyFiltered: "Keine Tests entsprechen diesem Filter.",
        loadError: "Bestellungen konnten nicht geladen werden.",
        invalidPatient: "Dieser Patientenlink ist ungültig.",
      },
    },

    reports: {
      table: {
        order: "Bestellung",
        test: "Test",
        substrate: "Substrat",
        completed: "Abgeschlossen",
        report: "Bericht",
      },
      empty: "Noch keine Berichte.",
      emptyFiltered: "Keine Berichte entsprechen diesen Filtern.",
      filters: {
        searchPlaceholder: "Suche nach Bestellung, Test-ID oder Substrat",
        dateAny: "Alle Daten",
        clear: "Zurücksetzen",
        done: "Fertig",
      },
      patient: {
        title: "Meine Berichte",
        subtitle: "Laborberichte, die mit Ihrem Konto verknüpft sind.",
        loadError: "Ihre Berichte konnten nicht geladen werden.",
      },
      therapist: {
        title: "Berichte",
        subtitle: "Berichte aller Patienten, die Ihnen zugeordnet sind.",
        loadError: "Berichte konnten nicht geladen werden.",
      },
    },

    patients: {
      title: "Meine Patienten",
      subtitle: "Patienten, deren Tests an Sie weitergeleitet werden.",
      searchPlaceholder: "Nach Patientenname suchen",
      emptySearch: "Keine Patienten entsprechen Ihrer Suche.",
      emptyAll: "Noch keine Patienten.",
      loadError: "Ihre Patienten konnten nicht geladen werden.",
      table: {
        patient: "Patient",
        dateOfBirth: "Geburtsdatum",
        tests: "Tests",
        latestTest: "Letzter Test",
      },
    },

    noAccess: {
      title: "Kein Portalzugriff für dieses Konto",
      subtitle:
        "Ihr Konto ist derzeit keinem Portal zugewiesen. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Support unter info@sibolab.de.",
    },
  },
};

export default de;
